import React from "react";
import { wrapCollectionLayout } from "@quintype/components";
import { StoryCard, StoryCardSimple } from "../basic/story-card.js";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { CollectionName } from "../basic/collection-name.js";
import "./two-col-highlight.module.css";
import { isExternalStory } from "../../utils";
import { collectionSection } from "./collection-layout-helper";

function TwoColHighlightBase({ stories = [], metadata = {}, collection, associatedMetadata, config }) {
  const length = stories ? stories.length : 0;
  const imageConfig = {
    image: true,
    imageAspectRatio: [4, 3]
  };
  const story = get(stories, [0], {});
  if (length < 4) {
    return <div data-comment="At least four stories required for a TwoColHighlight" />;
  }
  const { show_collection_title: collectionName = true } = associatedMetadata;
  return (
    <div styleName="component-wrapper" data-test-id="two-col-highlight-component">
      {collectionName ? <CollectionName name={collection.name} section={collection} type="large" /> : null}
      <div styleName="container">
        <div styleName="story-with-highlighted-card fix-height">
          <Link href={`/${story.slug}`} externalLink={isExternalStory(story)} className="story-card-link">
            <StoryCardSimple
              config={imageConfig}
              pickOfTheDay={true}
              story={story}
              hideSectionName={true}
              titleofTheHighlightedStory={metadata.titleofTheHighlightedStory}
              aspectRatio={[4, 3]}
            />
          </Link>
        </div>
        <div styleName="story-with-card fix-height">
          {stories.slice(1, 4).map(story => {
            return (
              <Link href={`/${story.slug}`} externalLink={isExternalStory(story)} className="story-card-link">
                <StoryCardSimple key={story.id} story={story} hideSectionName={true} config={imageConfig} />
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export const TwoColHighlight = wrapCollectionLayout(TwoColHighlightBase);
